// Lightweight in-memory capture of recent console errors & runtime errors
// so a bug report can auto-attach technical evidence.
const MAX = 40;
const buffer = [];

function push(kind, msg) {
  buffer.push(`[${new Date().toISOString()}] ${kind}: ${msg}`);
  if (buffer.length > MAX) buffer.shift();
}

let initialized = false;
export function initLogBuffer() {
  if (initialized) return;
  initialized = true;

  const origError = console.error.bind(console);
  console.error = (...args) => {
    try {
      push("console.error", args.map(stringify).join(" "));
    } catch (_) {}
    origError(...args);
  };

  const origWarn = console.warn.bind(console);
  console.warn = (...args) => {
    try {
      push("console.warn", args.map(stringify).join(" "));
    } catch (_) {}
    origWarn(...args);
  };

  window.addEventListener("error", (e) => {
    push("window.error", `${e.message} @ ${e.filename}:${e.lineno}`);
  });
  window.addEventListener("unhandledrejection", (e) => {
    push("unhandledrejection", stringify(e.reason));
  });
}

function stringify(v) {
  if (typeof v === "string") return v;
  try {
    return JSON.stringify(v);
  } catch (_) {
    return String(v);
  }
}

export function getLogs() {
  return buffer.join("\n");
}
